import BaseInput from '../_input/input';

const SELECTOR_FIELD = '.input-textarea__field';

/**
 * @class InputTextarea
 */
export default class InputTextarea extends BaseInput {
	init() {
		super.init(SELECTOR_FIELD);
	}

	bindEvents() {
		this.on('blur', SELECTOR_FIELD, this.onBlur.bind(this));
	}

	onBlur() {
		this.checkValidity();
	}
}
